<template>
  <v-card>
    <v-card-title>
      <span class="title">New</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <form @submit.prevent="formSubmit">
        <v-text-field
          v-model="company.company_code"
          label="Company code"
          :error-messages="errors.collect('company code')"
          v-validate="'required|max:4'"
          data-vv-name="company code"
          required
          :counter="4"
        ></v-text-field>

        <v-text-field
          v-model="company.description"
          label="Description"
          :error-messages="errors.collect('description')"
          v-validate="'required'"
          data-vv-name="description"
          required
        ></v-text-field>

        <v-btn @click="formSubmit" color="accent" dark :loading="isLoading" :disable="isLoading">save</v-btn>
        <v-btn @click="clear" color="accent" dark>clear</v-btn>
        <v-btn to="/company">cancel</v-btn>
      </form>
    </v-card-text>

    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'new-company',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      company: {
        company_code: '',
        description: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  computed: {
    ...mapGetters(['getLoading', 'getResponse'])
  },
  methods: {
    ...mapActions(['addCompany']),

    formSubmit: function () {
      this.loader = 'loading'

      this.$validator.validateAll().then(result => {
        if (result) {
          this.addCompany(this.company)
            .then(() => {
              let response = this.getResponse
              this.snackbar = true
              this.text =
                response.status === 200
                  ? 'Added successfully.'
                  : response.data.message
              this.color = response.status === 200 ? 'success' : 'error'
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },

    clear: function () {
      this.company.description = ''
      this.company.company_code = ''
    }
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/company/NewCompany.vue